import React, { useRef } from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import useRouteName from "../../hooks/useRouteName.js";
import { TravellerFooter } from "@bookingcom/web-shell";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useUserAgent from "../../hooks/useUserAgent.js";
import { useTrackLandingPageViewport } from "../../hooks/c360/useLandingPageEvents.js";
import usePointOfSale from "../../hooks/usePointOfSale.js";
const NO_FOOTER_PAGE_LIST = [
    "checkout-fare",
    "checkout-seat-selection",
    "checkout-sirf",
    "checkout-start",
    "checkout-ticket-type",
    "checkout-pax",
    "checkout-extras",
    "checkout-payment",
    "confirmation",
    "pb-checkout-payment",
    "alternative-fares"
];
function FooterFallback() {
    const i18n = useI18n();
    const pos = usePointOfSale();
    return (React.createElement(TravellerFooter, { isDotCN: pos === "cn", variant: "minimal", footerItems: [], copyrightText: React.createElement("div", { style: { textAlign: "center" }, "data-testid": "footer_booking_holdings" },
            React.createElement("div", null, i18n.trans(t("footer_booking_holdings", { variables: { b_companyname: "Booking.com" } }))),
            React.createElement("div", null, i18n.trans(t("flights_footer_copyright", {
                variables: { copyright_symbol: "©", b_companyname: "Booking.com", year: new Date().getFullYear() }
            })))) }));
}
export default function Footer() {
    const routeName = useRouteName();
    const { isMobile } = useUserAgent();
    const { isWebview } = useUserAgent();
    const remoteFooter = useRemoteComponent({
        project: "web-shell",
        service: "header-mfe",
        path: "/TravellerFooter/Flights",
        type: "capla"
    }, {
        fallbackComponent: FooterFallback
    });
    const scrollRef = useRef(null);
    useTrackLandingPageViewport(scrollRef, "whole_page");
    if (routeName === "not-available" ||
        (isMobile && routeName.includes("flightdetails")) ||
        (isMobile && isWebview && routeName.includes("searchresults")) ||
        (isMobile && isWebview && routeName === "home") ||
        NO_FOOTER_PAGE_LIST.includes(routeName)) {
        return null;
    }
    const { Component } = remoteFooter;
    return (React.createElement("div", { ref: scrollRef },
        React.createElement(Component, null)));
}
